<template>
  <div class="cmc-card">
    <div class="cmc-hero" :style="heroStyle">
      <div class="cmc-bubble">
        {{ titulo }}
      </div>
      <img :src="avatar" class="cmc-avatar" alt="">
    </div>
    <div class="cmc-footer">
      <b-badge
        v-for="tag in tags"
        :key="tag"
        class="cmc-tag"
        variant="secondary"
      >
        {{ tag }}
      </b-badge>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CardModeloChat',
  props: {
    descricao: {
      type: String,
      default: 'Some quick example text to build on the card title and make up.',
    },
    titulo: {
      type: String,
      default: 'Gere leads interessados em marketing digital para empresas',
    },
    avatar: {
      type: String,
      default: 'https://chat-booster.s3.amazonaws.com/img/avata_defaults/Ramon.png',
    },
    tags: {
      type: Array,
      default: () => ['Serviços de Tecnologia', 'ERP'],
    },
    cor: {
      type: String,
      default: '#00cfe8',
    },
  },
  computed: {
    heroStyle() {
      const base = this.cor || '#00cfe8'
      return {
        background: `linear-gradient(135deg, ${base} 0%, rgba(15,23,36,0.28) 150%)`,
      }
    },
  },
}
</script>

<style scoped lang="scss">
.cmc-card {
  display: flex;
  flex-direction: column;
  overflow: hidden;
  border-radius: 12px;
  border: 1px solid rgba(255, 255, 255, 0.08);
  background: #0f1724;
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.28);
  transition: transform .16s ease, box-shadow .16s ease, border-color .16s ease;
}

.cmc-card:hover {
  cursor: pointer;
  transform: translateY(-2px);
  border-color: rgba(232, 106, 16, 0.34);
  box-shadow: 0 12px 28px rgba(0, 0, 0, 0.35), 0 0 0 1px rgba(232, 106, 16, 0.16);
}

.cmc-hero {
  position: relative;
  min-height: 122px;
  padding: 16px 62px 12px 14px;
  display: flex;
  align-items: center;
}

.cmc-bubble {
  position: relative;
  border-radius: 12px;
  padding: 12px 14px;
  border: 1px solid rgba(255, 255, 255, 0.22);
  box-shadow: 0 6px 14px rgba(0, 0, 0, 0.2);
  color: #24364d !important;
  background: #f8fafc;
  line-height: 1.35;
  font-size: 16px;
  font-weight: 500;
}

.cmc-bubble::before {
  content: "";
  position: absolute;
  top: 22px;
  right: -14px;
  width: 0;
  height: 0;
  border-top: 8px solid transparent;
  border-left: 8px solid #f8fafc;
  border-right: 8px solid transparent;
  border-bottom: 8px solid transparent;
}

.cmc-avatar {
  position: absolute;
  right: 14px;
  top: 26px;
  width: 46px;
  height: 46px;
  border-radius: 50%;
  border: 2px solid rgba(255, 255, 255, 0.88);
  box-shadow: 0 3px 10px rgba(0, 0, 0, 0.3);
  object-fit: cover;
}

.cmc-footer {
  padding: 10px 12px;
  background: rgba(255, 255, 255, 0.06);
  border-top: 1px solid rgba(255, 255, 255, 0.08);
}

.cmc-tag {
  padding: 6px 11px !important;
  margin-right: 8px;
  border-radius: 999px;
  border: 1px solid rgba(255, 255, 255, 0.18);
  background: rgba(15, 23, 36, 0.42) !important;
  color: #e2e8f0 !important;
  font-size: 12px;
  font-weight: 700;
  letter-spacing: .01em;
}
</style>
